<template>
    <div class="flex-col justify-start relative page">
        <div class="flex-col justify-start items-center" v-if="onePage" style="z-index: 9999;" @click="playVideo">
            <!-- <img class="image_1" src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.gif" /> -->
            <video class="image_1" autoplay muted loop playsinline webkit-playsinline object-fit="cover"
                style=" position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;" poster="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.jpg">
                <source src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.mp4"
                    type="video/mp4">
            </video>
            <img class="image_2" src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/img1.png" />
        </div>


        <div class="sujm" v-show="!onePage">
            <!-- <div class="header">
                <div class="heatop">
                    <div class="logo" @click="back">
                        <img src="@/assets/logo.png" alt="">
                    </div>
                </div>
            </div> -->
            <div class="content" style="position: relative;">
                <div class="flex-col section_2 pos flex-col items-center justify-center" v-show="!onePage">
                    <!-- <img src="@/assets/images/二维码.png" alt="" class="ewm" /> -->
                    <img :src="ewm" alt="" class="ewm" />
                    <!-- <img src="@/assets/imglv1/wz3.png" alt="" class="ewm-desc" /> -->
                    <div class="bigtit" :class="motif == 3 ? 'color3' : ''">时空连线</div>
                </div>
                <div>

                    <!-- <div class="flex-col justify-start section_3 pos_2" v-if="motif == 3">
                        <div class="content-right-top"
                            v-if="details.pc_dynamic_upright_video || details.pc_static_upright_video">
                            <video v-show="audioURL" object-fit="cover" :muted="true" loop :controls="false" autoplay
                                :src="getURL(details.pc_dynamic_upright_video)" @error="videoError"
                                class="content-right-top-img" @play="setVideoRate"></video>
                            <video v-show="!audioURL" object-fit="cover" :muted="true" loop :controls="false" autoplay
                                :src="getURL(details.pc_static_upright_video)" @error="videoError"
                                class="content-right-top-img" @play="setVideoRate" @loadeddata="loadeddata"
                                poster="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.jpg"></video>
                        </div>

                        <div class="Nodataimg image" v-else>
                            <img class="" src="@/assets/imglv1/Nodataimg.png" />
                            <div class="wz">暂无内容</div>
                        </div>

                    </div> -->

                    <div class="flex-col justify-start section_1 pos_2">
                        <!-- <div class="content-right-top"
                            v-if="details.pc_dynamic_upright_video || details.pc_static_upright_video || details.upright_greeting_video"> -->
                        <div class="content-right-top">
                            <!-- 首次加载的视频 -->
                            <!-- <video v-if="startpage" object-fit="cover" :controls="false" autoplay
                                :src="getURL(details.upright_greeting_video)" @error="videoError"
                                class="content-right-top-img" @ended="handleVideoEnded"
                                poster="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.gif"></video> -->
                            <video v-show="startpage" object-fit="cover" :controls="false"
                                :src="getURL(details.upright_greeting_video)" @error="videoError"
                                class="content-right-top-img" id="video1" @ended="handleVideoEnded"
                                poster="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.jpg"></video>
                            <!-- 如果音频则正在说话出现动态视频 -->
                            <video v-show="audioURL && !startpage" object-fit="cover" :muted="true" loop
                                :controls="false" autoplay :src="getURL(details.pc_dynamic_upright_video)"
                                @error="videoError" class="content-right-top-img" @play="setVideoRate"
                                @loadeddata="loadeddata1"
                                poster="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.jpg"></video>
                            <!-- 没音频静态视频 -->
                            <video v-show="!audioURL && !startpage" object-fit="cover" :muted="true" loop
                                :controls="false" autoplay :src="getURL(details.pc_static_upright_video)"
                                @error="videoError" class="content-right-top-img" @play="setVideoRate"
                                @loadeddata="loadeddata"
                                poster="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/shupvideoposter.jpg"></video>
                        </div>

                        <!-- <div class="Nodataimg image" v-else>
                            <img class="" src="@/assets/imglv1/Nodataimg.png" />
                            <div class="wz">暂无内容</div>
                        </div> -->

                    </div>

                </div>



            </div>
        </div>

        <audio :src="audioURL" autoplay v-if="audioURL" class="audio" @play="setVideoRate" @ended="endAudio"
            @error="errorAudio"></audio>
        <div class="weixin-pop" id="weixinPop">
            <img class="img" src="@/assets/imglv1/weixin-pop.ccf34458.png" alt="">
        </div>
    </div>
</template>
<script>
import QRCode from "qrcode";
import { getVideoAudioList, onlinedetileGet, getVideogreeting } from "@/api/go";
export default {
    components: {},
    beforeRouteEnter(to, from, next) {
        let s = to.query.s;
        if (s) {
            if (s == 1) {
                next({
                    name: "index",
                    query: to.query
                });
            } else if (s == 2) {
                next({
                    name: "farewell",
                    query: to.query
                });
            } else if (s == 3) {
                next();
            }
        } else {
            next();
        }
    },
    data() {
        return {
            id: "",
            ewm: "",
            tcp: null,

            oldId: 0,
            audioList: [],
            audioURL: "",
            historyAudio: [],
            audioTime: "",
            hasTools: !this.$route.query.s,
            motif: 1,
            details: '',
            poster: true,
            audioURL_zc: '',
            startpage: true,//用来判断是否加载带声音的视频
            onePage: true,
        };
    },
    mounted() {
        this.motif = localStorage.getItem('motif') || 1
        console.log("---", this.playbackRate);

        // 当前是否是移动微信浏览器 微信官方js判断做法
        const userAgent = navigator.userAgent;
        const isWeixin = /MicroMessenger/i.test(userAgent) && /Mobile/i.test(userAgent);
        if (isWeixin) {
            var weixinPop = document.getElementById('weixinPop');
            weixinPop.style.display = 'block';
        }
    },
    computed: {
        playbackRate() {
            return (this.details || {}).speech_speed || 0.9;
        }
    },
    watch: {
        playbackRate: {
            immediate: true,
            handler() {
                this.setVideoRate();
            }
        }
    },
    methods: {
        tourl(ty) {
            if (ty == 0) {
                this.$router.replace({
                    name: "index",
                    query: {
                        id: this.id
                    }
                });
            } else if (ty == 1) {
                this.$router.replace({
                    name: "farewell",
                    query: {
                        id: this.id
                    }
                });
            } else if (ty == 2) {
                this.$router.replace({
                    name: "VideoAnimation",
                    query: {
                        id: this.id
                    }
                });
            }

        },
        back() {
            this.$router.replace({
                name: "list",
                query: {
                    id: this.id
                }
            });
        },
        computedPicture(url) {
            var imgurl = `https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/imglv1/theme${this.motif}/${url}.png`
            return imgurl
        },
        handleCommand(ty) {
            this.motif = ty
            localStorage.setItem('motif', ty);
        },
        setVideoRate() {
            // console.log('开始播放')
            // this.poster = false
            this.$nextTick(() => {
                [...document.querySelectorAll("video,audio")].forEach(item => {
                    item.playbackRate = this.playbackRate;
                });
            });
        },
        getEWM() {
            console.log(location.origin +
                `/mobile?id=${this.id
                }&type=1&userImage=${encodeURIComponent(this.details.image)}`)
            // QRCode.toDataURL(
            //   location.origin +
            //   location.pathname +
            //   `?time=${Date.now()}/mobile?id=${this.id
            //   }&type=1&userImage=${encodeURIComponent(this.details.image)}`
            // )
            //   .then(url => {
            //     this.ewm = url;
            //   })
            //   .catch(err => {
            //     console.error(err);
            //   });
            QRCode.toDataURL(
                location.origin + `/mobile?id=${this.id
                }&type=1&userImage=${encodeURIComponent(this.details.image)}`
            )
                .then(url => {
                    this.ewm = url;
                })
                .catch(err => {
                    console.error(err);
                });
        },
        playVideo(event) {
            const video = document.querySelector('#video1');
            if (video && video.paused) {
                video.play();
                this.onePage = false; // 隐藏封面图片
            }
        },
        videoError(err) {
            console.log(err, err.target.errMsg);
        },
        getURL(url) {
            if (!url) {
                return url;
            }
            if (url.includes("http")) {
                return url;
            } else {
                return `https://immortal-space.oss-cn-hangzhou.aliyuncs.com` + url;
            }
        },
        getVideoAudioList() {
            return getVideoAudioList({
                userId: this.$route.query.id,
                debug: process.env.NODE_ENV == "development" ? "1" : "0",
                iid: this.oldId
            }).then(res => {
                (res || []).forEach(element => {
                    if (
                        !this.audioList.some(v => v.replyAudioUrl == element.replyAudioUrl)
                    ) {
                        this.audioList.push(element);
                    }
                });
                if ((res || []).length > 0) {
                    this.oldId = res.at(-1).identifyRecordId;
                }

                if (!this.audioURL) {
                    this.initAudio();
                }
            });
        },

        initAudio() {
            // 没有audioURL,进行初始化
            // console.log("init");
            let details = this.audioList.find(
                v => !this.historyAudio.includes(v.replyAudioUrl)
            );
            if (details) {
                this.setAduio(details.replyAudioUrl);
            }
        },
        setAduio(url) {
            console.log("url", url);
            if (url != this.audioURL) {
                this.audioURL = url;
                this.historyAudio.push(url);
            }
        },
        endAudio() {
            console.log("-------end----------");
            let details = this.audioList.find(
                v => !this.historyAudio.includes(v.replyAudioUrl)
            );
            if (details) {
                this.setAduio(details.replyAudioUrl);
            } else {
                this.audioURL = null;
            }
            // 播放结束，播放下一条
        },
        errorAudio() {
            console.log("-------err----------");
            let details = this.audioList.find(
                v => !this.historyAudio.includes(v.replyAudioUrl)
            );
            if (details) {
                this.setAduio(details.replyAudioUrl);
            } else {
                this.audioURL = null;
            }
        },

        // 获取信息
        detileData() {
            let that = this
            onlinedetileGet({
                userId: Number(that.id)
            }).then(res => {
                console.log(res)
                if (res.auth_config) {
                    that.details = res
                    that.getEWM();
                    if (res.upright_greeting_video == '' || !res.upright_greeting_video) {
                        that.startpage = false
                    }
                }
            }).catch(err => {

            });
        },
        handleVideoEnded() {
            console.log('视频播放结束');
            this.startpage = false
            this.onePage = false
        },
        loadeddata() {
            // // 视频加载完成，海报取消，执行相应操作
            // console.log('静态视频加载完成，海报取消，执行相应操作', this.audioURL_zc)
            // // 如果没有加载首屏打招呼信息 有的话就不加载
            // if (!this.audioURL_zc) {
            //     getVideogreeting({
            //         userId: Number(this.id)
            //     }).then(res => {
            //         console.log(res)
            //         this.audioURL_zc = res
            //     }).catch(err => {
            //         console.log(res)
            //     });
            // }

        },

        loadeddata1() {
            // 视频加载完成，海报取消，执行相应操作
            // console.log('动态视频加载完成，海报取消，执行相应操作', this.audioURL_zc)
            // let that = this
            // setTimeout(() => {
            //     if (that.audioURL_zc) {
            //         that.audioURL = that.audioURL_zc
            //     } else {
            //         that.loadeddata1()
            //     }
            // }, 300)
        }


    },
    created() {
        this.id = this.$route.query.id;
        this.detileData()

        this.getVideoAudioList();
        window.timer = setInterval(() => {
            this.getVideoAudioList();
        }, 2000);
    },
    beforeDestroy() {
        clearInterval(window.timer);
    }
};
</script>
<style lang="less" scoped>
.page {
    width: 100%;
    height: 100%;

    .image_1 {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        object-fit: cover;
        z-index: 1;
    }

    .image_2 {
        width: 100vw;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 10;
    }


    .sujm {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .section_2 {
        position: absolute;
        overflow: hidden;
        // background: url(~@/assets/images/video-left.png);
        background-size: 100% 100%;
        bottom: 200px;
        right: 80px;
        z-index: 9999;

        .ewm {
            width: 300px;
            height: 300px;
        }

        .ewm-desc {
            width: 275px;
            margin-bottom: 50px;
        }
    }

    .bg5 {
        background: #292c35 !important;
    }

    .section_3 {
        position: relative;
        overflow: hidden;
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .content-right-top {
            object-fit: cover;
            width: 100%;
            height: 100%;
            background: url('~@/assets/imglv1/theme3/videobg1.png');
            background-size: 100% 100%;
        }

        .content-right-top-img {
            width: 96%;
            height: 85%;
            object-fit: cover;
            position: absolute;
            bottom: 20px;
            left: 20px;
            right: 20px;
        }

        .content-right-desc {
            margin-top: 36px;
            height: 195px;
            color: #a5e1e1;
            font-size: 16px;
            line-height: 32.68px;
            text-align: justify;
            padding-right: 20px;
            overflow-y: auto;
        }
    }

    .section_1 {
        position: relative;
        overflow: hidden;
        width: 100vw;
        height: 100vh;
        // padding: 20px;
        // background: #fff;
        border: 20px solid #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .content-right-top {
            object-fit: cover;
            width: 100%;
            height: 100%;
            // background: url(~@/assets/images/video-phone.png);
            background-size: 100% 100%;
        }

        .content-right-top-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .content-right-desc {
            margin-top: 36px;
            height: 195px;
            color: #a5e1e1;
            font-size: 16px;
            line-height: 32.68px;
            text-align: justify;
            padding-right: 20px;
            overflow-y: auto;
        }
    }


    .Nodataimg {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
            width: 100vw;
            // height: 100vh;
        }

        .wz {
            font-size: 80px;
            color: #fff;
            font-weight: bold;
            margin-top: 20px;
        }
    }
}

.audio {
    position: fixed;
    right: 200%;
    z-index: -1;
}

.back {
    position: fixed;
    left: 50px;
    top: 50px;
    width: 198px;
    height: 66px;
    cursor: pointer;
}

.group-right {
    margin-top: 36px;
    text-align: center;

    .button {
        padding: 16px 22px 15px 26px;
        border-radius: 33px;
        // background: rgba(10, 26, 52, 0.4);
        // border: 1.65px solid rgba(89, 175, 249, 0.7049);
        // box-shadow: inset 0px 0px 8.25px 0.5px rgba(3, 251, 255, 0.6513);
        // color: #01c2ff;
        cursor: pointer;
        width: max-content;

        &+.button {
            margin-left: 90px;
        }

        img {
            width: 34px;
            margin-right: 8px;
        }

        .tools-button {
            font-size: 26px;
            font-family: 思源黑体;
            line-height: 33px;
            font-weight: 700;
        }
    }
}

.header {
    .heatop {
        padding-top: 60px;
        padding-right: 50px;
        padding-left: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 35px;

        .logo {
            color: #fff;
            font-weight: bold;
            cursor: pointer;

            img {
                height: 40px;
            }
        }
    }

    .Togglebackg5 {
        background: #212121;
    }

    .Togglebackg6 {
        background: #F6AB87;
    }

    .Toggle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 0;
        margin-top: 20px;

        .Toggle_l {
            padding-left: 220px;
            display: flex;
            align-items: center;

            .Togglelist {
                cursor: pointer;
                font-size: 34px;
                margin-right: 95px;
                position: relative;
                color: #FFFFFF;

                .xzlist {
                    width: 240px;
                    height: 68px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 38px;
                        margin-right: 5px;
                    }
                }
            }
        }

        .Toggle_r {
            padding-right: 60px;
            display: flex;
            align-items: center;
            height: 80px;

            .el-dropdown-link {
                display: flex;
                align-items: center;
                font-size: 34px;
                color: #FFFFFF;
                font-weight: 500;

                img {
                    width: 50px;
                    // height: 30px;
                }

                .Togglelist {
                    cursor: pointer;
                    font-size: 38px;
                    margin-right: 95px;
                    position: relative;
                    color: #FFFFFF;

                    .xzlist {
                        width: 250px;
                        height: 83px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);


                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 38px;
                            margin-right: 5px;
                        }
                    }
                }
            }
        }
    }
}

.bigtit {
    text-align: center;
    font-size: 70px;
    font-weight: bold;
    transform: skewX(-5deg);
    color: #fff;
    padding: 30px 0;
    letter-spacing: 4px;
}

.color3 {
    color: #A5E1E1;
}

.opc {
    opacity: 0;
}

.poster {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #000;
    z-index: 9999;
}
</style>